module.exports = __webpack_public_path__ + "statics/img/detailCompany.7b0f2931.png";